const RequestProduct = () =>{
    return (
        <> 
            <h1>반송/폐기 요청 (재고 건)</h1>
        </>
    )
}

export default RequestProduct